<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <span class="text-muted">
          <b>Soil Texture Characteristics</b>
        </span>
      </b-card-header>
      <b-card-body>
        <b-table 
          :fields="columns"
          :items="formResultData(results)"
          bordered
          fixed
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { soil_texture_characteristics } from "@/shared/result-table-fields";
import ReportResultFormat from "@/components/shared/mixins/ReportResultFormat";
import ResultModel from "@/models/modus/ResultModel";

export default {
  name: "SoilTextureCharacteristicsTable",
  props: {
    results: {
      type: Object,
      default: () => new ResultModel(),
    },
  },
  mixins: [ ReportResultFormat ],
  computed: {
    columns() {
      return [
        { key: "id", label: "Lab ID" },
        { key: "depth", label: "Depth" },
        ...soil_texture_characteristics.map(item => {
          return {
            key: item.element,
            label: `${item.element} ${item.unit || ''} ${item.ratio || ''}`
          };
        })
      ];
    }
  },
};
</script>
